jQuery(document).ready(function () {
    if ($(".scroll-box-swiper")[0]) {

        swiper = new Swiper($(".scroll-box-init-swiper"), {
            direction: "vertical",
            slidesPerView: "auto",
            autoHeight: true,
            freeMode: true,

            scrollbar: {
                el: ".swiper-scrollbar",
            },
            mousewheel: true,
            draggable: true,
        });

        $('.card > .collapse').filter('.show').each(function () {

            swiper = new Swiper($(this).find('.scroll-box-advantages'), {
                direction: "vertical",
                slidesPerView: "auto",
                autoHeight: true,
                freeMode: true,

                scrollbar: {
                    el: ".swiper-scrollbar",
                },
                mousewheel: true,
                draggable: true,
            });
        })
        $('.btn-link').click(function () {
            setTimeout(function () {
                $('.card > .collapse').filter('.show').each(function () {
                    if(!($(this).find('.scroll-box-advantages').hasClass('.swiper-container-initialized'))) {
                        swiper = new Swiper($(this).find('.scroll-box-advantages'), {
                            direction: "vertical",
                            slidesPerView: "auto",
                            freeMode: true,

                            scrollbar: {
                                el: ".swiper-scrollbar",
                            },
                            mousewheel: true,
                            draggable: true,
                        });
                    }
                })
            }, 390);
        })

    }


});